module.exports = __webpack_public_path__ + "img/ai-ali.f10c2606.png";